// extracted by mini-css-extract-plugin
export var authorNameStyle = "quote_small_center_aligned-module--authorNameStyle--XP8NU";
export var quoteAttributionStyle = "quote_small_center_aligned-module--quoteAttributionStyle--zILyV";
export var quoteBodyStyle = "quote_small_center_aligned-module--quoteBodyStyle--z2yCM";
export var textColorDarkStyle = "quote_small_center_aligned-module--textColorDarkStyle--Pd+D0";
export var textColorLightStyle = "quote_small_center_aligned-module--textColorLightStyle--CWOJA";